import type {Repository} from '@github-ui/current-repository'
import {CommitGroup} from '../components/Commits/CommitGroup'
import {DeferredCommitDataProvider, baseEmptyStateNotLoading} from '../contexts/DeferredCommitDataContext'
import type {CommitGroup as CommitGroupType, DeferredData} from '../types/commits-types'

export type CommitsProps = {
  buildCommitPath?: (args: {owner: string; repo: string; commitish: string}) => string
  leadingContent?: React.ReactNode
  commitGroups: CommitGroupType[]
  trailingContent?: React.ReactNode
  repository: Repository
  deferredCommitData?: DeferredData
  currentBlobPath?: string
  shouldClipTimeline?: boolean
}

export function Commits({
  buildCommitPath,
  leadingContent,
  commitGroups,
  trailingContent,
  deferredCommitData = baseEmptyStateNotLoading,
  repository,
  currentBlobPath,
  shouldClipTimeline = true,
}: CommitsProps) {
  return (
    <DeferredCommitDataProvider deferredData={deferredCommitData}>
      {leadingContent}

      {commitGroups.map((commitGroup, index) => {
        return (
          <CommitGroup
            key={commitGroup.title}
            title={commitGroup.title}
            buildCommitPath={buildCommitPath}
            commits={commitGroup.commits}
            shouldClipTimeline={shouldClipTimeline && index === 0}
            currentBlobPath={currentBlobPath}
            repo={repository}
          />
        )
      })}

      {trailingContent}
    </DeferredCommitDataProvider>
  )
}

try{ Commits.displayName ||= 'Commits' } catch {}